const DashBrancoIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    version="1.1"
    id="Camada_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 3000 3000"
  >
    <g>
      <path
        className="st0"
        d="M1194.8,123.7c3.7,15.2,170.5,713.1,188.6,787.5c1.6,6.6,0.5,10.9-4.1,15.8
		c-123.9,133-401.6,431.8-417.4,448.8c-282-93.4-564.1-186.9-847.1-280.6c1.1-4.2,2.1-7.9,3-11.6c15.8-60.7,42.2-117.1,70.5-172.7
		C259.7,770.1,351.4,644.1,462,531.6C576.7,415,707.2,319.9,852.5,244.9c76.8-39.7,156.6-72,238.9-97.9c23.9-7.5,49-11.5,73.6-17
		C1174.6,127.9,1184.3,125.9,1194.8,123.7z"
      />
      <path
        className="st0"
        d="M1354.1,330.3c11.1-2.1,21.7-4.3,32.4-6.1c53-8.9,106.4-15.8,160.2-14.4c39.4,1,78.8,3.6,118.1,7.5
		c40.2,3.9,80.3,9.2,120.2,15.7c114.3,18.6,223.1,54.5,327.4,104.8c127.5,61.5,241,142.8,342.5,241.2
		c68.6,66.5,130.1,138.8,180.7,220.1c24.5,39.4,60,107.6,76.2,146.5c-3,1.5-464.1,204.9-515.9,228c-6.4,2.9-11.1,2.8-17.2-1.2
		C1938.9,1115.2,1699,958,1458.9,801.1c-6.2-4-9-8.7-10.4-15.6c-24.2-116.1-86.4-413.1-93.1-445.6
		C1354.8,337.1,1354.6,334.1,1354.1,330.3z"
      />
      <path
        className="st0"
        d="M2846.9,1924.4c-14.4,65.3-34.5,127.5-58.9,188.4c-64.6,161.4-158.9,303.1-281.8,425.9
		c-98.9,98.8-211.4,178.7-338.1,240.8c-148.2-286.7-296.1-573-445.1-861.3C2098.5,1920.2,2471.9,1922.3,2846.9,1924.4z"
      />
      <path
        className="st0"
        d="M269.6,1257.7c209.3,64.4,417.8,128.5,627.9,193.1c-3.6,4.3-183.6,212.3-271.1,313.4
		c-10.3,11.9-9.2,7-3.7,21.5c127,333.5,384,1008.5,386.1,1014.5c-4.4-1.7-7.3-2.7-10.1-4c-108.7-50.3-209.3-113.3-300.4-191.1
		c-214.1-182.9-357.4-410.5-429.4-682.8c-16.7-63.2-28-127.5-34.9-192.5c-7.8-73.1-9.3-146.2-5.2-219.5
		c4.7-82.7,18.6-163.9,38.3-244.2C267.6,1263.8,268.4,1261.6,269.6,1257.7z"
      />
      <path
        className="st0"
        d="M2802.8,1142.4c17.9,39.8,29.2,80.6,40.5,121.4c32.1,115.6,44.4,233.5,41.6,353.2c-1,40.9-2.4,81.9-8.7,124.1
		c-201.8-132.9-402.3-265.1-604.3-398.2C2449.4,1275.8,2625.3,1209.4,2802.8,1142.4z"
      />
      <path
        className="st0"
        d="M775.2,1910.4c-2.8-7.1,5.1-13.6,11.5-9.6c155.9,96.2,1180.3,732.4,1183.5,735.7
		c10.3,11,67.4,129.3,90.9,174.6c7.6,14.6,2.7,21.6-11,25.6c-48.9,14-97.8,28.2-146.9,41.6c-31.6,8.6-63.2,18.1-95.5,23.3
		c-52.8,8.5-105.9,17-159.2,19.9c-62.8,3.4-126,2.5-188.9,0.1c-35.4-1.3-70.6-9.2-105.8-14.5c-24.4-3.7-48.9-6.8-72.9-12.1
		c-35-7.7-70.3-15.2-104-26.8c-11-3.8-20.7-19.1-25.8-31.3c-38.2-91.1-75-182.7-112.2-274.1c-46.3-113.8-92.4-227.6-138.8-341.3
		C865,2135,798.4,1969.8,775.2,1910.4z"
      />
      <path
        className="st0"
        d="M1753.3,1832.2c-4.6,0-6.1-6.1-2.1-8.3l550.8-304.5c13.4-7.5,22.4-7.1,35,1.2
		c127.7,85.5,379.9,252.9,440.5,293.2c4.1,2.7,2.2,9-2.7,9.1C2669.9,1824.3,2075.4,1831.9,1753.3,1832.2z"
      />
      <path
        className="st0"
        d="M1522.2,977.6c-10.9-7.3-16.6-6.9-25.7,3.2c-158.8,175.4-656.7,745.4-735.4,838.2c-4.3,5.1-0.7,12.8,5.9,12.8
		c86.9,0.4,494.7,0.4,714.1,1.3c30.7,0.1,57.7-7.1,83.7-21.3c111.4-60.6,222.5-121.7,334.1-181.9c93.4-50.4,310.9-167,328.2-177.1
		C2218.7,1446.3,1719.8,1110.7,1522.2,977.6z M1597.2,1547.3c-47.9,0.5-87-37.7-87.5-85.3c-0.5-47,39.3-87.1,86.4-87.1
		c47.4-0.1,86.6,39.3,86.5,86.8C1682.5,1508.8,1644.5,1546.9,1597.2,1547.3z"
      />
    </g>
  </svg>
);
export default DashBrancoIcon;
